import {Component, OnInit} from '@angular/core';
import {CashbackService} from '../../../../core/service/cashback.service';
import {ActivatedRoute, Router} from '@angular/router';
import {ShopDetails} from '../../../../core/models/shopDetails';
import {Coupon} from '../../../../core/models/coupon';
import {ClipboardService} from 'ngx-clipboard';
import {TranslatePipe} from '@ngx-translate/core';
import {ToastrService} from 'ngx-toastr';

@Component({
  selector: 'app-cashback-shop-details',
  templateUrl: './cashback-shop-details.component.html',
  styleUrls: ['./cashback-shop-details.component.scss'],
  providers: [TranslatePipe]
})
export class CashbackShopDetailsComponent implements OnInit {

  public shopId: string;
  public shop: ShopDetails;
  public shopCoupons: Array<Coupon> = [];
  public selectedCoupon: Coupon;
  public subdomain: string;

  constructor(private cashbackService: CashbackService,
    private activeRoute: ActivatedRoute,
    private router: Router,
    private translate: TranslatePipe,
    private toastrService: ToastrService) {
    this.subdomain = this.activeRoute.snapshot.params['subdomain'];
    this.shopId = this.activeRoute.snapshot.params['shopId'];
  }

  ngOnInit(): void {
    this.activeRoute.params.subscribe(params => {
      this.shopId = params['shopId'];
      this.getShopDetails();
    });
  }

  loadCashback(shop: ShopDetails) {
    this.cashbackService.getCashbackLink(shop.id).subscribe({
      next: value => {
        window.open(value);
      },
      error: err => {
        this.toastrService.error(
          this.translate.transform('CASHBACK.DETAILS_PAGE.LOAD_FAILED'),
          this.translate.transform('ERROR'),
          {toastClass: 'toast ngx-toastr', closeButton: true, timeOut: 3000}
        );
      }
    });
  }

  private getShopDetails() {
    if (this.shopId && this.shopId.trim() !== '') {
      this.cashbackService.getShopDetails(this.shopId).subscribe({
        next: value => {
          this.shop = value;
          this.shopCoupons = this.shop.coupons;
        },
        error: err => {
          this.toastrService.error(
            this.translate.transform('CASHBACK.DETAILS_PAGE.LOAD_FAILED'),
            this.translate.transform('ERROR'),
            {toastClass: 'toast ngx-toastr', closeButton: true, timeOut: 3000}
          );
          this.router.navigate([`${this.subdomain}/deals`]);
        }
      });
    }
  }
}
